export const fetchSessionsFiltersUrl = `/sessions/list/filters`;
export const fetchSessionsListUrl = `/sessions`;
export const fetchSessionsInfoUrl = `/sessions`;
export const fetchSessionsCloseUrl = `/sessions`;
export const fetchSessionsExportExcelUrl = `/sessions/export/excel`;
export const fetchSessionsExportHTMLUrl = `/sessions/export/html`;
